<div class="landing-overlay"></div>

<div class="landing">
  <div class="center-content">
    <div class="landing-title">{{ 'landing_title' | translate }}</div>
    <div class="landing-subtitle">{{ 'landing_subtitle' | translate }}</div>

    <div class="icons-container">
      <div class="icon-box">
        <img src="/assets/img/landing-access.png"/>
        <div class="icons-title">
          {{ 'landing_box_1_title' | translate }}
        </div>
      </div>

      <div class="arrow-box">
        <img src="/assets/img/landing-arrow.svg"/>
      </div>

      <div class="icon-box">
        <img src="/assets/img/landing-upload.png"/>
        <div class="icons-title">
          {{ 'landing_box_2_title' | translate }}
        </div>
      </div>

      <div class="arrow-box">
        <img src="/assets/img/landing-arrow.svg"/>
      </div>

      <div class="icon-box">
        <img src="/assets/img/landing-advantages.png"/>
        <div class="icons-title">
          {{ 'landing_box_3_title' | translate }}
        </div>
      </div>
    </div>
  </div>

  <button class="coupon-button landing-button" (click)="goToLogin()">
    {{ 'landing_start_button' | translate }}
  </button>
</div>
